import { render } from "./CardAttribuees.vue?vue&type=template&id=5ef77a10&scoped=true"
import script from "./CardAttribuees.vue?vue&type=script&lang=js"
export * from "./CardAttribuees.vue?vue&type=script&lang=js"

import "./CardAttribuees.vue?vue&type=style&index=0&id=5ef77a10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef77a10"]])

export default __exports__